import React from "react";
import { Typography, Container, Grid} from "@mui/material";
// import MetaData from "../component/layouts/MataData/MataData";
import AboutImage1 from "../../Images/Akb-images/About_us/2.jpg";
import AboutImage2 from "../../Images/Akb-images/About_us/1.jpg";
// import { Link } from "react-router-dom";
import "./profile.css"

const Profile = () => {

  return (
    <>
      <div className="about_us">
        {/* <MetaData title={"About Us"} /> */}
        <Container className="container_12">
        <Typography
                variant="h2"
                component="h1"
                className="title_about"
              >
                Profile
              </Typography>
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} sm={6}>
              <img
                src={AboutImage1}
                alt="Dr. Anjani Kumar Bhatnagar"
                className="image_about"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1" className="introText_about">
              Dr. Anjani Kumar Bhatnagar is having a rich experience of Industry & Academia of more than 18 years. 
              He is an enabler, strategist and positive thinker. Currently associated with India’s Top Ranked Private Education Group, 
              Amity, a hub of more than 2,00,000 students, having campuses in 16 countries across the globe. 
              With an almost two-decade-old association with Amity, he is responsible for bringing excellence in the field of Campus Placements, 
              Industry alliances & Grooming of students. He has been the face of Amity for aligning industries of various formats & to get students deserving and prosperous start to their careers through corporate connect initiatives, 
              and industry mentorship by putting extreme focus on Moral Values and Business Ethics. 
              <br />
              During his tenure at Amity, he has worked closely with the Top Management and has outperformed in areas like Placements, 
              Corporate tie-ups, Establishment of a Group of Engineering Schools across the nation, Alumni Association, Summer School Program and many more.
              <br />
              He has been the Key member in organizing the first-ever mega Alumni Meet at Amity University. 
              To bring further excellence into the field of education and make the youth of India more versatile he visited Many Top Academic & Industrial Setups based in Europe, 
              Dubai, Singapore, Austria etc. Dr Bhatnagar has remained successful in securing 30+ Government Funded, 
              DST Projects based on Technology and Entrepreneurship for the entire Amity Education Group.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
            <Typography variant="body1" className="introText_about">
            Being the Organizing Secretary, he has also organized various IEEE-sponsored International Conferences at various Amity Campuses in India and abroad.
            He has more than 50 MoUs on his account signed between Amity and Top Global Organizations. 
            At Amity he has also convened 14 Industry Excellence Awards with participation from over 500 CEOs/Chairmans/CXOs / HR Heads and other senior officials from Private & Government Sectors.

            <br />
            He is a science Graduate from the University of Delhi and a post-graduate with a specialization in Marketing and International Business from Guru Gobind Singh Indraprastha University, 
            New Delhi. Completed PhD in Management and have published several research articles in Top Indexed Journals. 
            <br />
            <br />
            He is also appointed as a President of- Alumni Association for DSPSR. 
            <br />
            <br />
            Email - anjani.kb@gmail.com

              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <img
                src={AboutImage2}
                alt="Dr. Anjani Kumar Bhatnagar"
                className="image_about"
              />
            </Grid>
          </Grid>
        </Container>
      </div>
    </>
  );
};

export default Profile;
